<!-- On peut avoir plusieures valeurs donc on utilise une boucle -->
<ul>
  <li *ngFor="let item of value"><span class="value">{{item}}</span></li>
</ul>
